
// Delivery and Pickup Custom options on cart and product page are created by Impulsebyte.com
// All the options are optimized for Local Delivery and Local Pickup only


// Function to log a message while waiting for the DOM to load
function logUntilDomLoaded() {
    if (document.readyState === 'complete') {
        console.log('IMPULSΞBYTE Delivery options has fully loaded.');
    } else {
        console.log('IMPULSΞBYTE Delivery options Loading...');
        setTimeout(logUntilDomLoaded, 100); // Retry after a short delay
    }
}

// Start logging immediately
logUntilDomLoaded();

// Select the date input element by its ID
const datepicker = document.getElementById('datepicker');

// Select the pickup time select element by its ID
const pickupTimeSelect = document.getElementById('pickup-time');

// Get the current date and time
const currentDate = new Date();
const currentHours = currentDate.getHours();
const currentMinutes = currentDate.getMinutes();

// Function to check if a date is a Sunday or Monday
function isSundayOrMonday(date) {
    const day = date.getDay(); // 0 is Sunday, 1 is Monday
    return day === 0 || day === 1;
}

// Define the date range to disable
    const startDate = '2024-02-18';
    const endDate = '2024-02-27';

// Initialize the date picker
const flatpickrInstance = flatpickr(datepicker, {
    dateFormat: 'Y-m-d', // Specify the date format
    minDate:  currentDate, // Disable past dates
    // Disable today's date if it's 4 PM or later
    disable: [
      {
                from: startDate,
                to: endDate
            },
            // Custom function to disable specific dates
            // function(date) {
            //     const day = date.getDate();
            //     return day === 9 || day === 10;
            // },
        function(date) {
            if (date.toDateString() === currentDate.toDateString()) {
                if (currentHours >= 16) {
                    return true;
                }
            }
            return false;
        },
        // Custom function to disable Sundays and Mondays
        function(date) {
            return isSundayOrMonday(date);
        }
    ],
    onChange: function(selectedDates, dateStr, instance) {
        // Check if the selected date is a Saturday (day 6)
        const selectedDate = selectedDates[0];
        const isSaturday = selectedDate.getDay() === 6;

        // Define the allowed pickup time range based on the selected date and current time
        let allowedTimes = [];


      // Function to reload necessary parts of the script for pickup option
function reloadScriptForPickup() {
    // Check if it's Saturday and update delivery options accordingly
    if (isSaturday) {
        // Disable local delivery for Saturdays
        document.querySelectorAll('.delivery-active .local-delivery-fields').forEach(element => {
            element.style.display = 'none';
        });
    } else {
        // Check if pickup is selected and hide local delivery fields if so
        const pickupOption = document.querySelector('.bcdp-method-wrap.pickup-only');
        if (pickupOption.classList.contains('bcdp-method-active')) {
            document.querySelectorAll('.pickup-active .local-delivery-fields').forEach(element => {
                element.style.display = 'none'; // Hide for pickup
            });
        } else {
            // Show local delivery fields for pickup if not selected
            document.querySelectorAll('.pickup-active .local-delivery-fields').forEach(element => {
                element.style.display = 'grid';
            });
        }
    }
}

// Add click event listener for Store Pickup option
storePickupOption.addEventListener('click', () => {
    // Call the function to reload script parts for pickup option
    reloadScriptForPickup();
});

// Function to be called during initial setup and whenever the date changes
function setupDateChange() {
    // Check if it's Saturday and update delivery options accordingly
    if (isSaturday) {
        // Disable local delivery for Saturdays
        document.querySelectorAll('.delivery-active .local-delivery-fields').forEach(element => {
            element.style.display = 'none';
        });
    } else {
        // Enable local delivery for other days
        document.querySelectorAll('.delivery-active .local-delivery-fields').forEach(element => {
            element.style.display = 'grid'; // Show for delivery
        });

        // Call the function to reload script parts for pickup option
        reloadScriptForPickup();
    }

    // Adjust allowed times for other days if needed
}

// Call the setup function initially
setupDateChange();

      

        // Check if it's Saturday and update delivery options accordingly
        if (isSaturday) {
          // Check if the notice already exists before adding it
    const deliveryNotice = document.querySelector('.bcdp-method-wrap.delivery-only p');
    if (!deliveryNotice) {
        // Create and append the notice indicating no local delivery on Saturdays
        const noticeText = document.createTextNode('Please note: Local delivery is not available on Saturdays.');
        const deliveryNotice = document.createElement('p');
        deliveryNotice.appendChild(noticeText);
        document.querySelector('.bcdp-method-wrap.delivery-only').appendChild(deliveryNotice);
    }
            allowedTimes = ['9:00 AM - 10:00 AM', '10:00 AM - 11:00 AM', '11:00 AM - 12:00 PM', '12:00 PM - 01:00 PM'];
        
        } else {
          // Remove the notice if it exists
    const deliveryNotice = document.querySelector('.bcdp-method-wrap.delivery-only p');
    if (deliveryNotice) {
        deliveryNotice.remove();
    }
                  
            // Determine available time slots based on the current time
            if (currentDate.getDate() === selectedDate.getDate()) {
                if (currentHours >= 17) { // If it's 5 PM or later
                    allowedTimes = ['10:00 AM - 11:00 AM', '11:00 AM - 12:00 PM', '12:00 PM - 01:00 PM', '01:00 PM - 02:00 PM', '02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
                } else if (currentHours < 10 || (currentHours === 10 && currentMinutes < 30)) {
                    allowedTimes = ['11:00 AM - 12:00 PM', '12:00 PM - 01:00 PM', '01:00 PM - 02:00 PM', '02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
                } else if ((currentHours === 10 && currentMinutes >= 30) || (currentHours === 11 && currentMinutes < 30)) {
                    allowedTimes = ['12:00 PM - 01:00 PM', '01:00 PM - 02:00 PM', '02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
                } else if (currentHours >= 12 && currentHours < 13) {
                    allowedTimes = ['01:00 PM - 02:00 PM', '02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
                } else if (currentHours >= 13 && currentHours < 14) {
                    allowedTimes = ['02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
                } else if (currentHours >= 14 && currentHours < 15) {
                    allowedTimes = ['03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
                } else if (currentHours >= 15 && currentHours < 17) { // Updated condition here
                    allowedTimes = ['04:00 PM - 05:00 PM'];
                }
            } else { // If it's a future day (15th, 16th, etc.)
                allowedTimes = ['10:00 AM - 11:00 AM', '11:00 AM - 12:00 PM', '12:00 PM - 01:00 PM', '01:00 PM - 02:00 PM', '02:00 PM - 03:00 PM', '03:00 PM - 04:00 PM', '04:00 PM - 05:00 PM'];
            }

        }



        // Clear existing options
        pickupTimeSelect.innerHTML = '';

        // Add the allowed pickup times as options
        allowedTimes.forEach(time => {
            const option = document.createElement('option');
            option.value = time;
            option.textContent = time;
            pickupTimeSelect.appendChild(option);
        });

        // Update the date input with the selected date (or the next available date)
        datepicker.value = dateStr;
    }
});



// Set the initial options for the pickup time select
const initialAllowedTimes = [
    '10:00 AM - 11:00 AM',
    '11:00 AM - 12:00 PM',
    '12:00 PM - 01:00 PM',
    '01:00 PM - 02:00 PM',
    '02:00 PM - 03:00 PM',
    '03:00 PM - 04:00 PM',
    '04:00 PM - 05:00 PM'
];

// Filter out any time slots that have passed
const currentHour = currentDate.getHours();
const currentMinute = currentDate.getMinutes();
const currentTime = `${currentHour}:${currentMinute}`;
const filteredTimes = initialAllowedTimes.filter(timeSlot => !hasTimePassed(timeSlot, currentTime));

// Add the filtered allowed pickup times as options
filteredTimes.forEach(time => {
    const option = document.createElement('option');
    option.value = time;
    option.textContent = time;
    pickupTimeSelect.appendChild(option);
});

// Set the initial date input value to the next available date
datepicker.value = getNextAvailableDate().toISOString().split('T')[0];

// Function to check if the current time has passed the given time
function hasTimePassed(endTime, currentTime) {
    const [endHour, endMinute] = endTime.split(' - ')[0].split(':');
    const [currentHour, currentMinute] = currentTime.split(':');
    return (
        parseInt(currentHour, 10) > parseInt(endHour, 10) ||
        (parseInt(currentHour, 10) === parseInt(endHour, 10) && parseInt(currentMinute, 10) >= parseInt(endMinute, 10))
    );
}

// Function to get the next available date with a start time of 10:00 AM
function getNextAvailableDate() {
    const nextDay = new Date(currentDate);
    nextDay.setDate(nextDay.getDate() + 1);

    // Set the time of the next available date to 10:00 AM
    nextDay.setHours(10, 0, 0, 0);

    // Find the next available date that is not a Sunday or Monday
    while (isSundayOrMonday(nextDay)) {
        nextDay.setDate(nextDay.getDate() + 1);
        nextDay.setHours(10, 0, 0, 0);
    }

    return nextDay;
}

// Get the elements for Local Delivery and Store Pickup
const localDeliveryOption = document.querySelector('.bcdp-method-wrap.delivery-only');
const storePickupOption = document.querySelector('.bcdp-method-wrap.pickup-only');
const bcdpWidgetContainer = document.querySelector('.bcdp-widget-container');
const localDeliveryFields = document.querySelectorAll('.local-delivery-fields input, .local-delivery-fields textarea');
const localPickupFields = document.querySelectorAll('.local-pickup-fields input, .local-pickup-fields textarea, .bcdp-time-container select');
const specialInput = document.getElementById('special_input');
const zipCodeInput = document.getElementById('ValidateZipCode');
const zipCodeCheckButton = document.getElementById('local_delivery_location_zip_button');
const zipCodeError = document.getElementById('zipCodeError');
const zipCodeSuccess = document.getElementById('zipCodeSuccess');
const deliveryDateInput = document.querySelector('.delivery-input-widget');
const calenderError = document.getElementById('calenderError');
const timeInput = document.getElementById("timeInput");
const timeContainer = document.getElementById("timeContainer");

localDeliveryOption.addEventListener('click', () => {
    // Check if it's past 1:00 PM
    if (currentHours >= 13) {
        // Hide today's date by setting minDate to tomorrow
        flatpickrInstance.set('minDate', new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1));
    }
});
storePickupOption.addEventListener('click', () => {
    flatpickrInstance.set('minDate', currentDate);
});

// List of valid zip codes
const validZipCodes = ['02018', '02043', '02044', //Hingham MA
    '02020', '02041', '02050', '02051', '02059', '02065', //Marshfield MA
    '02339', //Hanover MA
    '02045', //Hull MA
    '02188', '02189', '02190', '02191', //Weymouth MA
    '02040', '02055', '02060', '02066', //Scituate MA
    '02025', //Cohasset MA
    '02327', '02358', '02359', //Pembroke MA
    '02331', '02332' //Duxbury MA
]; // Add your valid zip codes here

// // Define a map of variant IDs to arrays of zip codes
// const zipCodeToVariantMap = {
//     '46989035929901': ['02020', '02041', '02050', '02051', '02059', '02065', '02327', '02358', '02359', '02331', '02332'],
//     '46835894255917': ['02339', '02045', '02188', '02189', '02190', '02191', '02040', '02055', '02060', '02025'],
//     // Add more variants and their associated zip codes as needed
// };

// // Shopify Store URL
// const shopifyStoreUrl = 'https://www.norngiftandgarden.com';

// // Cart URL (Make sure to get the correct cart URL)
// const cartUrl = `${shopifyStoreUrl}/cart/update.js`;

// // Get the elements
// const checkoutButton = document.querySelector('[name="checkout"]');

// // Variable to store the current zip code and associated variant ID
// let currentZipCode = '';
// let currentVariantId = '';

// // Function to update the cart based on the entered zip code and variant ID
// function updateCart(zipCode, variantId) {
//     // Create the payload for the request to update the cart
//     const payload = {
//         updates: {
//             [variantId]: 1, // Add 1 quantity of the new variant
//             [currentVariantId]: 0, // Set the quantity of the current variant to 0 (remove it)
//         },
//     };

//     // Make a POST request to update the cart
//     fetch(cartUrl, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload),
//     })
//         .then(response => response.json())
//         .then(cart => {
//             // Handle the response data as needed
//             console.log('Cart updated:', cart);

//             // Enable or disable the Checkout button based on zip code validity
//             if (zipCodeToVariantMap.hasOwnProperty(zipCode)) {
//                 checkoutButton.removeAttribute('disabled');
//             } else {
//                 checkoutButton.setAttribute('disabled', 'true');
//             }
//         })
//         .catch(error => {
//             // Handle errors
//             console.error('Error updating cart:', error);
//         });
// }

// // Add an event listener to the Zip Code input field for input changes
// zipCodeInput.addEventListener('input', () => {
//     // Get the entered zip code from the input field
//     const enteredZipCode = zipCodeInput.value.trim();

//     // Validate that the input consists only of numeric characters
//     const isNumericZipCode = /^\d+$/.test(enteredZipCode);
//   const isValidZipCode = validZipCodes.includes(enteredZipCode);

//     // Check if the entered zip code is in the list of valid zip codes and has an associated variant
//     if (isNumericZipCode && zipCodeToVariantMap.hasOwnProperty(enteredZipCode)) {
//         // Get the associated variant ID
//         const variantId = zipCodeToVariantMap[enteredZipCode];

//         // Show the success message and enable the Checkout button
//         zipCodeError.style.display = 'none';
//         zipCodeSuccess.style.display = 'block';
//         checkoutButton.removeAttribute('disabled');

//         // Check if the zip code or variant has changed
//         if (enteredZipCode !== currentZipCode || variantId !== currentVariantId) {
//             // Update the cart based on the new zip code and variant
//             updateCart(enteredZipCode, variantId);

//             // Update the current zip code and variant
//             currentZipCode = enteredZipCode;
//             currentVariantId = variantId;
//         }
//     } else {
//         // Show the error message and disable the Checkout button
//         zipCodeError.style.display = 'block';
//         zipCodeSuccess.style.display = 'none';
//         checkoutButton.setAttribute('disabled', 'true');
//     }
// });



// Add an event listener to the Zip Code input field for input changes
zipCodeInput.addEventListener('input', () => {
    const enteredZipCode = zipCodeInput.value.trim();

    // Validate that the input consists only of numeric characters
    const isNumericZipCode = /^\d+$/.test(enteredZipCode);

    // Check if the entered zip code is in the list of valid zip codes
    const isValidZipCode = validZipCodes.includes(enteredZipCode);

    // Show or hide the error and success messages based on zip code validity
    if (!isNumericZipCode) {
        zipCodeError.style.display = 'block';
        zipCodeSuccess.style.display = 'none';
    } else if (isValidZipCode) {
        zipCodeError.style.display = 'none';
        zipCodeSuccess.style.display = 'block';
    } else {
        zipCodeError.style.display = 'block';
        zipCodeSuccess.style.display = 'none';
    }

    // Enable or disable the Checkout button based on zip code validity
    const checkoutButton = document.querySelector('[name="checkout"]');
    if (isValidZipCode) {
        checkoutButton.removeAttribute('disabled');
    } else {
        checkoutButton.setAttribute('disabled', 'true');
    }
});


// Add an event listener to the pickup-only element
const pickupOnlyElement = document.querySelector('.bcdp-method-wrap.pickup-only');
pickupOnlyElement.addEventListener('click', () => {
    // Clear all fields in the local-pickup-fields section
    const pickupFields = document.querySelectorAll('.local-pickup-fields input, div#timeContainer select');
    const checkoutsButton = document.querySelector('[name="checkout"]');
    pickupFields.forEach((field) => {
        field.value = '';
    });

    // Clear the delivery date input
    deliveryDateInput.value = '';

    // Update the checkout button state
    updateCheckoutButtonState();
    checkoutsButton.removeAttribute('disabled');
});

// Add an event listener to the delivery-only element
const deliveryOnlyElement = document.querySelector('.bcdp-method-wrap.delivery-only');
deliveryOnlyElement.addEventListener('click', () => {
    // Clear all fields in the local-delivery-fields section
    const deliveryFields = document.querySelectorAll('.local-delivery-fields input, .local-delivery-fields textarea');
    deliveryFields.forEach((field) => {
        field.value = '';
    });

    // Clear the delivery date input
    deliveryDateInput.value = '';

    // Update the checkout button state
    updateCheckoutButtonState();
});
// Define the updateCheckoutButtonState function
function updateCheckoutButtonState() {
    const enteredZipCode = zipCodeInput.value.trim();
    const isNumericZipCode = /^\d+$/.test(enteredZipCode);
    const isValidZipCode = validZipCodes.includes(enteredZipCode);
    const selectedDate = new Date(deliveryDateInput.value);

    // Check if the selected date is not a weekend (Tuesday to Saturday)
    //const isWeekday = !isWeekend(selectedDate);

    // Check if either "pickup-only" or "delivery-only" is selected
    const isPickupOnly = pickupOnlyElement.classList.contains('selected');
    const isDeliveryOnly = deliveryOnlyElement.classList.contains('selected');

    // Determine whether the checkout button should be enabled
    const isCheckoutEnabled = isValidZipCode && isNumericZipCode && (isPickupOnly || isDeliveryOnly);

    // Get a reference to the checkout button
    const checkoutButton = document.querySelector('[name="checkout"]');

    // Enable or disable the Checkout button based on the conditions
    if (isCheckoutEnabled) {
        checkoutButton.removeAttribute('disabled');
    } else {
        checkoutButton.setAttribute('disabled', 'true');
    }
}



// Add click event listener for Local Delivery option
localDeliveryOption.addEventListener('click', () => {
    // Add the value attribute to the special_input element
    specialInput.value = 'Local Delivery';

    // Add the bcdp-method-active class to the selected option
    localDeliveryOption.classList.add('bcdp-method-active');

    // Remove the bcdp-method-active class from the other option
    storePickupOption.classList.remove('bcdp-method-active');

    // Add the delivery-active class to the bcdp-widget-container
    bcdpWidgetContainer.classList.add('delivery-active');

    // Remove the pickup-active class if present
    bcdpWidgetContainer.classList.remove('pickup-active');

    // Toggle the required attribute for input and textarea elements
    localDeliveryFields.forEach(field => {
        field.setAttribute('required', 'required');
    });

    localPickupFields.forEach(field => {
        field.removeAttribute('required');
    });
});

// Add click event listener for Store Pickup option
storePickupOption.addEventListener('click', () => {
    // Add the value attribute to the special_input element
    specialInput.value = 'Store Pickup';

    // Add the bcdp-method-active class to the selected option
    storePickupOption.classList.add('bcdp-method-active');

    // Remove the bcdp-method-active class from the other option
    localDeliveryOption.classList.remove('bcdp-method-active');

    // Add the pickup-active class to the bcdp-widget-container
    bcdpWidgetContainer.classList.add('pickup-active');

    // Remove the delivery-active class if present
    bcdpWidgetContainer.classList.remove('delivery-active');

    // Toggle the required attribute for input and textarea elements
    localPickupFields.forEach(field => {
        field.setAttribute('required', 'required');
    });

    localDeliveryFields.forEach(field => {
        field.removeAttribute('required');
    });
});